import styles from './TermsPage.module.css';
import React, { useEffect } from 'react';
import { Footer } from 'abu-common-components';
import TravellerTermsAndConditions from '../../components/travellerTermsAndConditions/TravellerTermsAndConditions';
import { useNavigate } from 'react-router-dom';

const TermsPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = 'Terms & Conditions | Booking.com';
  }, []);
  return (
    <div className={styles.homeContainer} data-testid="termPageTestId">
      <TravellerTermsAndConditions />
      <div className={styles.footerContent}>
        <Footer
          onTermsClick={() => navigate('/terms')}
          onPrivacyClick={() => navigate('/privacy')}
        />
      </div>
    </div>
  );
};

export default TermsPage;
